import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

const ArrowBtn = ({ hideOnMobile, hideOnDesktop, buttonColor, url, link, title, buttonClass = '', disableUrl }) => (
  <>
    {url &&
        <a target='_blank' rel='noopener noreferrer' href={url}
           onClick={(e) => {
               e.preventDefault();
              !disableUrl && window.open(url);
           }}
           className={`${hideOnMobile ? 'hideOnMobile' : ''}
                       ${hideOnDesktop ? 'hideOnDesktop' : ''} ${buttonClass}`
           }>
            <div
                className={`arrow_btn ${buttonColor === 'black' ? 'black' : buttonColor === 'grey' ? 'grey' : 'white'}`}>
                <div className='arrow_btn_text'>
                    {title}
                </div>
                <div className='arrow_btn_icon'>
                    <img
                        src={`/media/icons/inclassica/arrow-right${buttonColor === 'black' ? '-black' : buttonColor === 'grey' ? '-grey' : ''}.svg`}
                        alt={`${title}-btn`}/>
                </div>
            </div>
        </a>
    }

    {link &&
        <Link to={link}
              className={`${hideOnMobile ? 'hideOnMobile' : ''}
                           ${hideOnDesktop ? 'hideOnDesktop' : ''} ${buttonClass}`
              }>
            <div
                className={`arrow_btn ${buttonColor === 'black' ? 'black' : buttonColor === 'grey' ? 'grey' : 'white'}`}>
                <div className='arrow_btn_text'>
                    {title}
                </div>
                <div className='arrow_btn_icon'>
                    <img
                        src={`/media/icons/inclassica/arrow-right${buttonColor === 'black' ? '-black' : buttonColor === 'grey' ? '-grey' : ''}.svg`}
                        alt={`${title}-btn`}/>
                </div>
            </div>
        </Link>
    }
  </>
);

ArrowBtn.propTypes = {
  hideOnMobile: PropTypes.bool,
  hideOnDesktop: PropTypes.bool,
  buttonColor: PropTypes.string,
  url: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  buttonClass: PropTypes.string,
};

export default memo(ArrowBtn);
